<template>
  <div class="flow no-select" v-loading="mainLoading">
    <!-- 左侧流程图配置 -->
    <node-paper
      ref="nodePaper"
      width="calc(100% - 450px)"
      :height="height"
      :nodeList="nodeList"
      :routeList="routeList"
      :inputList="inputList"
      :curNode="curNode"
      :curRoute="curRoute"
      :nodeIden="nodeIden"
      :inputType="inputType"
      :inputTitle="inputTitle"
      @modifyNodeList="modifyNodeList"
      @setCurNode="setCurNode"
      @setNodeIden="setNodeIden"
      @getRelateNode="getRelateNode"
      @setCurNodeField="setCurNodeField"
      @setCudShow="setCudShow"
      @setInputShow="setInputShow"
      @setCurRoute="setCurRoute">
    </node-paper>
    <!-- 左侧流程图配置 -->
    <node-config
      ref="nodeConfig"
      :height="height"
      width="450px"
      :curNode="curNode"
      :nodeList="nodeList"
      :routeList="routeList"
      :inputList="inputList"
      :users="users"
      :structs="structs"
      :groups="groups"
      :posts="posts"
      v-show="curRoute.start_iden === undefined">
    </node-config>
    <route-config
      :curRoute="curRoute"
      :height="height"
      width="450px"
      v-show="curRoute.start_iden !== undefined">
    </route-config>
    <div style="clear:both"></div>
    <input-list 
      ref="inputList"
      :inputList="tempInputList"
      @setNewInputList="setNewInputList"
      @openDepentConfig="openDepentConfig"
      @setKeyDepent="setKeyDepent"
      @confirmDepentConfig="confirmDepentConfig">
      </input-list>
    <depent-config
      ref="depentConfig"
      :keyDepent="keyDepent"
      :showName="showName">
    </depent-config>
    <input-config
      ref="inputConfig"
      :inputList="inputList"
      :curNode="curNode"
      :curGroupIds="curGroupIds"
      :inputTitle="inputTitle"
      :inputType="inputType"
      :isFullInputData="false"
      :needCondition="false"
      :modifyNode="modifyNode"
      :showConfig="showConfig"
      @setInputShow="setInputShow"
      @setInputListShow="setInputListShow"
      @confirmCurField="confirmCurField"
      @resetTempInputList="resetTempInputList"
      @setCurGroupIds="setCurGroupIds">
    </input-config>
    <cud-config
      ref="cudConfig"
      :modelId="modelId"
      :cudConfig="curNode.cud_config"
      @setCudConfig="setCudConfig">
    </cud-config>
    <div class="fl m-t-10">
      <el-button @click="importData">导入数据</el-button>
      <el-button @click="exportData">导出数据</el-button>
    </div>
    <div class="tx-c m-t-10">
      <el-button type="primary" @click="save()" :loading="isLoading">提交</el-button>
      <el-button @click="goback()">返回</el-button>
    </div>
    <div>
      <input id="importFile" type="file" v-show="false" @change="importFileChange">
      <a id="exportData" href="#" download v-show="false"></a>
    </div>
  </div>
</template>

<script>
  import http from '../../../assets/js/http'
  import flowConfig from '../../../config/flowConfig'
  import modelConfig from '../../../config/modelConfig'
  import nodeConfig from './nodeConfig'
  import inputConfig from '../../Common/business/inputConfig/inputConfig'
  import inputList from '../../Common/business/inputConfig/inputList'
  import depentConfig from '../../Common/business/inputConfig/depentConfig'
  import cudConfig from '../../Common/business/cudConfig'
  import routeConfig from './routeConfig'
  import nodePaper from './nodePaper'
  // ele类型
  // 开始节点：10
  // 任务节点：20
  // 审批网关：30
  // 变量判断网关：40
  // 报告生成：50（暂无）
  // 结束节点：60
  // 文本备注：70
  // 执行函数：80
  // 路由：100
  export default {
    data() {
      return {
        id: '',
        modelId: -1,
        height: '',
        mainLoading: true,
        isLoading: false,
        nodeList: [],   // 节点数组
        routeList: [], // 路由数组
        curNode: {
          receive_user: {
            back_higher_status: 0,
            founder_higher_status: 0,
            founder_status: 0,
            free_status: 0
          },
          present_type: 10, // 接收类型
          rollback_config: 10, // 回退人
          user_ids: [],
          struct_ids: [],
          group_ids: [],
          post_ids: [],
          examine_rule: 10, // 审批规则
          connect_type: 10, // 连接类型
          variable: [], // 变量判断网关
          field: [], // 关联控件列表
          examine_iden: '',
          examine: [],
          functions: {
            function_name: '',
            package_name: '',
            params: [],
            return_params: []
          }, // 执行函数
          cud_config: [], // cud配置
          notify_config: {  // 知会消息接收人配置
            receive_user: { // 接收人配置
              back_higher_status: 0, // 上一级处理人上级
              founder_higher_status: 0, // 发起人上级
              founder_status: 0,      // 发起人
              free_status: 0,         // 自定义配置
              related_field_status: 0 // 关联字段配置
            },
            related_field_config: {
              field_id: '',
              related_field_id: ''
            },
            present_type: 0,
            user_ids: [],   // 选中用户id
            group_ids: [], // 选中用户组id
            struct_ids: [],  // 选中的部门id
            is_reset_notify: 0,  // 是否重置消息通知
            msg_title: 0,        // 消息标题
            msg_content: 0       // 消息内容
          }
        }, // 当前节点
        curRoute: {},
        curGroupIds: [], // 可见分组的id
        nodeIden: 1, // 节点唯一标识当前可取值
        users: [], // 人员数组
        structs: [], // 部门数组
        groups: [], // 用户分组
        posts: [], // 岗位数组
        inputList: [], // 控件数组
        inputType: [], // 以id为索引的控件类型
        inputTitle: [], // 以id为索引的控件名
        inputShow: false, // 显示选择控件弹窗
        inputListShow: false, // 显示选择控件弹窗
        // deleteConfirmShow: false, // 显示确定删除分组弹窗
        tempInputList: [],
        keyDepent: [], // 当前外键的从属字段数组
        showName: [], // 当前外键配置的显示字段数组
        modifyNode: [], // 复制节点数据
        showConfig: true
      }
    },
    mixins: [http, modelConfig, flowConfig],
    created() {
      this.id = this.$route.params.id
      this.init()
      this.getFlowInfo()
      this.getInputList()
      this.getUsers()
      this.getStructs()
      this.getGroups()
      // this.getPosts()
    },
    methods: {
      needDepentConfig(item) {
        return item.default.type == this.TYPE_FOREIGNKEY && item.auth == this.INPUT_EDITABLE
      },
      isDisabled(item) {
        return item.disabled || item.default.type == this.TYPE_DEALTIME
      },
      modifyNodeList(nodeList) {
        this.modifyNode = nodeList
      },
      // 初始化，绑定事件
      init() {
        this.resize()
        window.onresize = () => {
          this.resize()
        }
      },
      // 设置窗口高度
      resize() {
        this.height = window.innerHeight - 150 + 'px'
      },
      // 初始化节点列表
      initNode() {
        this.nodeList.push({
          size: {
            width: '90px',
            height: '90px'
          },
          pos: {
            left: '150px',
            top: '50px'
          },
          type: 10,
          name: '开始',
          iden: 0,
          receive_user: {
            back_higher_status: 0,
            founder_higher_status: 0,
            founder_status: 0,
            free_status: 0
          },
          present_type: 40, // 接收类型
          rollback_config: 10, // 回退人
          user_ids: [],
          struct_ids: [],
          group_ids: [],
          post_ids: [],
          examine_rule: 10, // 审批规则
          connect_type: 10, // 连接类型
          variable: [], // 变量判断网关
          field: [], // 关联控件列表
          examine_iden: '',
          examine: [],
          related_field_config: {
            field_id: '',
            related_field_id: ''
          },
          functions: { // 执行函数
            function_name: '',
            package_name: '',
            params: [],
            return_params: []
          },
          notify_config: {  // 知会消息接收人配置
            receive_user: { // 接收人配置
              back_higher_status: 0, // 上一级处理人上级
              founder_higher_status: 0, // 发起人上级
              founder_status: 0,      // 发起人
              free_status: 0,         // 自定义配置
              related_field_status: 0 // 关联字段配置
            },
            related_field_config: {
              field_id: '',
              related_field_id: ''
            },
            present_type: 0,
            user_ids: [],   // 选中用户id
            group_ids: [], // 选中用户组id
            struct_ids: [],  // 选中的部门id
            is_reset_notify: 0,  // 是否重置消息通知
            msg_title: 0,        // 消息标题
            msg_content: 0       // 消息内容
          }
        })
        this.curNode = this.nodeList[0]
        // console.log(this.curNode)
      },
      // onScroll(event, position) {
      //   this.scrollOfs = position
      // },
      // 获取流程详情
      getFlowInfo() {
        this.apiGet(`bpm/flows/${this.id}/nodes`).then((res) => {
          if (res.code == 200) {
            if (res.data) {
              if (!_g.isRealEmpty(res.data.node)) {
                _(res.data.node).forEach((item) => {
                  if (_g.isRealEmpty(item.group)) { // 增加分组
                    item.group = []
                  }
                  if (!item.related_field_config) { // 兼容接收方关联字段旧数据
                    item.related_field_config = {
                      field_id: '',
                      related_field_id: ''
                    }
                  }
                  if (item.notify_config) {  // 有知会消息配置
                    let newField = {
                      is_reset_notify: 0,
                      msg_title: '',
                      msg_content: ''
                    }
                    _(newField).forEach((field, key) => {
                      if (!item.notify_config.hasOwnProperty(key)) {
                        item.notify_config[key] = field
                      }
                    })
                  }
                })
              }
              this.initFlowData(res.data.node, res.data.route)
              this.modifyNode = res.data.node
            } else {
              this.initNode()
            }
          } else {
            _g.dealError(this, res)
          }
          this.mainLoading = false
        })
      },
      setCurGroupIds(tempCurGroupIds) {
        this.curGroupIds = Array.from(new Set(tempCurGroupIds))
        this.curGroupIds.sort(this.sortNumber)
      },
      sortNumber(a, b) {
        return a - b
      },
      initFlowData(node, route) {
        _(node).forEach((res) => {
          if (res.type == this.TYPE_APPROVE) {
            let index = _.findIndex(res.examine, (item) => {
              return item.examine_type == 10
            })
            // if (res.examine && res.examine.length > 0) {
            //   res.examine_iden = res.examine[index].iden
            // }
          }
        })
        _(route).forEach((res) => {
          res.path = `M ${res.start_x} ${res.start_y} T ${res.end_x} ${res.end_y}`
        })
        this.nodeList = node
        this.nodeIden = this.nodeList[this.nodeList.length - 1].iden + 1
        this.routeList = route
        this.curNode = this.nodeList[0]
        setTimeout(() => {
          this.mainLoading = false
        }, 100)
      },
      // 获取用户
      getUsers() {
        let params = {
          params: {
            status: 1
          }
        }
        this.apiGet('admin/users', params).then((res) => {
          if (res.code == 200) {
            this.users = res.data.list
          } else {
            _g.dealError(this, res)
          }
        })
      },
      // 获取组织架构
      getStructs() {
        let params = {
          params: {
            status: 1
          }
        }
        this.apiGet('admin/structures', params).then((res) => {
          if (res.code == 200) {
            this.structs = res.data
          } else {
            _g.dealError(this, res)
          }
        })
      },
      // 获取用户组
      getGroups() {
        let params = {
          params: {
            status: 1
          }
        }
        this.apiGet('admin/groups', params).then((res) => {
          if (res.code == 200) {
            this.groups = res.data
          } else {
            _g.dealError(this, res)
          }
        })
      },
      // 获取岗位
      // getPosts() {
      //   this.apiGet('admin/posts').then((res) => {
      //     if (res.code == 200) {
      //       this.posts = res.data
      //     } else {
      //       _g.dealError(this, res)
      //     }
      //   })
      // },
      // 获取模型id
      getModelId() {
        return new Promise((resolve, reject) => {
          this.apiGet(`bpm/flows/${this.id}`).then((res) => {
            if (res.code == 200) {
              resolve(res.data.model_id)
            } else {
              resolve('')
            }
          })
        })
      },
      // 获取控件列表
      async getInputList() {
        this.modelId = await this.getModelId()
        if (!this.modelId) {
          return
        }
        this.apiGet(`form/models/${this.modelId}/fields`).then((res) => {
          if (res.code == 200) {
            _(res.data).forEach((item) => {
              item.selected = false
            })
            this.inputList = res.data
            _(this.inputList).forEach((res) => {
              this.inputTitle[res.default.field_id] = res.default.title
              this.inputType[res.default.field_id] = res.default.type
            })
          } else {
            _g.dealError(this, res)
          }
        })
      },
      sortGroupId(fields) { // 整理分组id,去重，排序
        let curGroupIds = []
        if (fields.length != 0) {
          fields.forEach((res) => {
            curGroupIds.push(parseInt(res.group_id))
          })
          this.curGroupIds = Array.from(new Set(curGroupIds))
          this.curGroupIds.sort(this.sortNumber)
        }
      },
      setCurNode(node) {
        this.curNode = node
      },
      setNodeIden(nodeIden) {
        this.nodeIden = nodeIden
      },
      getRelateNode() {
        this.$refs.nodeConfig.getRelateNode()
      },
      setCurNodeField(field) {
        this.sortGroupId(field)
        this.$refs.inputConfig.setCurField(field)
      },
      confirmCurField(field) {
        this.$refs.nodePaper.setCurNodeField(field)
      },
      setCudShow(value) {
        if (value) {
          this.$refs.cudConfig.openDialog()
        } else {
          this.$refs.cudConfig.closeDialog()
        }
      },
      setInputShow(value) {
        if (value) {
          this.$refs.inputConfig.openDialog()
        } else {
          this.$refs.inputConfig.closeDialog()
        }
      },
      setInputListShow(value) {
        if (value) {
          this.$refs.inputList.openDialog()
        } else {
          this.$refs.inputList.closeDialog()
        }
      },
      resetTempInputList(field, ids) {  // 根据已选控件设置禁用状态
        let tempInputList = _.cloneDeep(this.inputList)
        let tempInputById = {}
        let key_cascade = {
          major_field: '',
          extra_field: ''
        }
        let option_relation = {
          major_field: '',
          relation: []
        }
        let person_struct_model = {
          major_field: '',
          filter_field: ''
        }
        if (field) {
          // 用临时数组保存所有控件权限
          _(field.inputs).forEach((res) => {
            let temp = {
              auth: res.field_auth,
              default: res.field_default != undefined ? res.field_default : null,
              key_major: res.key_major != undefined ? res.key_major : '',
              key_depent: res.key_depent != undefined ? res.key_depent : [],
              key_filter: res.key_filter != undefined && (_.isArray(res.key_filter)) ? res.key_filter : [], // 筛选条件
              key_fillin: res.key_fillin != undefined ? res.key_fillin : [],
              key_cascade: res.key_cascade != undefined ? res.key_cascade : _.cloneDeep(key_cascade),
              logic_condition: res.logic_condition != undefined ? res.logic_condition : [],
              option_relation: res.option_relation != undefined && !(_.isArray(res.option_relation)) ? res.option_relation : _.cloneDeep(option_relation),
              people_filter: res.people_filter != undefined ? res.people_filter : _.cloneDeep(person_struct_model),
              struct_filter: res.struct_filter != undefined ? res.struct_filter : _.cloneDeep(person_struct_model)
            }
            tempInputById[res.field_id] = temp
          })
          _(tempInputList).forEach((res) => {
            // 设置控件权限
            if (tempInputById[res.default.field_id]) {
              if (tempInputById[res.default.field_id].auth) {
                res.auth = tempInputById[res.default.field_id].auth
              } else {
                res.auth = this.INPUT_HIDDEN
              }
              res.field_default = tempInputById[res.default.field_id].default
              res.key_major = tempInputById[res.default.field_id].key_major
              res.key_depent = tempInputById[res.default.field_id].key_depent
              res.key_filter = _.cloneDeep(tempInputById[res.default.field_id].key_filter)
              res.key_fillin = _.cloneDeep(tempInputById[res.default.field_id].key_fillin)
              res.key_cascade = _.cloneDeep(tempInputById[res.default.field_id].key_cascade)
              res.logic_condition = _.cloneDeep(tempInputById[res.default.field_id].logic_condition)
              res.option_relation = _.cloneDeep(tempInputById[res.default.field_id].option_relation)
              res.people_filter = _.cloneDeep(tempInputById[res.default.field_id].people_filter)
              res.struct_filter = _.cloneDeep(tempInputById[res.default.field_id].struct_filter)
            } else {
              res.auth = this.INPUT_HIDDEN
              res.field_default = null
              res.key_major = ''
              res.key_depent = []
              res.key_filter = []
              res.key_fillin = []
              res.key_cascade = _.cloneDeep(key_cascade)
              res.logic_condition = []
              res.option_relation = _.cloneDeep(option_relation)
              res.people_filter = _.cloneDeep(person_struct_model)
              res.struct_filter = _.cloneDeep(person_struct_model)
            }
            if (_.findIndex(ids, (id) => {
              return id == res.default.field_id
            }) > -1) {
              // 控件已存在别的分组
              res.disabled = true
            }
          })
        }
        this.tempInputList = tempInputList
      },
      setNewInputList(newInputList) {
        this.$refs.inputConfig.setNewInputList(newInputList)
      },
      setTempInputType(type) {
        _(this.tempInputList).forEach((res) => {
          if (!res.disabled) {
            res.auth = type
          }
        })
      },
      setCurRoute(route) {
        this.curRoute = route
      },
      setKeyDepent(keyDepent, showName) {
        this.keyDepent = keyDepent
        this.showName = showName
      },
      confirmDepentConfig(keyDepent) {
        this.$refs.inputList.confirmDepentConfig(keyDepent)
      },
      openDepentConfig() {
        this.$refs.depentConfig.openDialog()
      },
      importFileChange() {
        let fileInput = document.getElementById('importFile')
        let file = fileInput.files[0]
        let fileReader = new FileReader()
        fileReader.onload = (event) => {
          _g.catchError(this, () => {
            let result = event.target.result
            result = JSON.parse(result)
            this.mainLoading = true
            this.initFlowData(result.node, result.route)
          }, '导入失败！')
        }
        fileReader.readAsText(file)
      },
      exportData() {
        let data = {
          node: this.nodeList,
          route: this.routeList
        }
        data = JSON.stringify(data)
        let blob = new Blob([data], { type: 'text/plain;charset=utf-8' })
        let a = document.getElementById('exportData')
        a.download = 'data.json'
        a.href = URL.createObjectURL(blob)
        a.click()
      },
      importData() {
        let fileInput = document.getElementById('importFile')
        fileInput.click()
      },
      setCudConfig(config) {
        this.curNode.cud_config = config
      },
      // 保存流程
      save() {
        this.isLoading = true
        let nodeList = _.cloneDeep(this.nodeList)
        _(nodeList).forEach((res) => {
          if (res.type == this.TYPE_APPROVE) {
            delete res.examine_iden
          }
        })
        let postData = {
          node: nodeList,
          route: this.routeList
        }
        this.apiPost(`bpm/flows/${this.id}/nodes`, postData).then((res) => {
          if (res.code == 200) {
            _g.toastMsg(this, 'success', '保存成功！')
            setTimeout(() => {
              this.goback()
            }, 1000)
          } else {
            _g.dealError(this, res)
          }
        })
        this.isLoading = false
      },
      // 返回
      goback() {
        router.go(-1)
      }
    },
    components: {
      nodePaper,
      nodeConfig,
      inputConfig,
      cudConfig,
      inputList,
      depentConfig,
      routeConfig
    }
  }
</script>


// WEBPACK FOOTER //
// design.vue?c1b58100